import { render, staticRenderFns } from "./CurrencyTableRow.vue?vue&type=template&id=c9637e20&scoped=true&"
import script from "./CurrencyTableRow.vue?vue&type=script&lang=js&"
export * from "./CurrencyTableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9637e20",
  null
  
)

export default component.exports